import React from 'react';
import styles from './scss/Input.module.scss';

interface InputErrorProps {
  errorMessage: string;
}

const InputError: React.FunctionComponent<InputErrorProps> = (props: InputErrorProps) => {
  const { errorMessage } = props;
  return (
    <p className={styles.inputError}>
      {errorMessage}
    </p>

  );
};

export default InputError;
